import BannerPromo from "./BannerPromo"
export default BannerPromo